import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { beautyBaseUrl } from "network";

export const categorySlice = createApi({
    reducerPath: "categorySlice",
    baseQuery: fetchBaseQuery({
        baseUrl: beautyBaseUrl,
        credentials: "include",
        prepareHeaders: (headers, { getState }) => {
            const state = getState();
            const token = state.auth?.token;
            if (token) {
                console.log('token', token);
                headers.set("authorization", `Bearer ${token}`);
            } else {
                console.warn("Token not found in state.auth");
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        // ✅ Get All Categories
        getCategories: builder.query({
            query: ({ page = 1, limit = 100, search = "" }) => ({
                url: `/categories?page=${page}&limit=${limit}&search=${search}`,
                method: "GET",
            }),
            transformResponse: (response) => response,
        }),

        // ✅ Add New Category
        addCategory: builder.mutation({
            query: (body) => ({
                url: "/categories",
                method: "POST",
                body,
            }),
        }),

        // ✅ Update Existing Category
        updateCategory: builder.mutation({
            query: ({ id, body }) => ({
                url: `/categories/${id}`,
                method: "PUT",
                body,
            }),
        }),

        // ✅ Delete Category
        deleteCategory: builder.mutation({
            query: (id) => ({
                url: `/categories/${id}`,
                method: "DELETE",
            }),
        }),
    }),
});

export const {
    useGetCategoriesQuery,
    useAddCategoryMutation,
    useUpdateCategoryMutation,
    useDeleteCategoryMutation
} = categorySlice;
